import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Layers } from 'lucide-react';

import { operationsState, operationsDialogOpenState } from '@chainlit/react-client';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export default function OperationsButton() {
  const operations = useRecoilValue(operationsState);
  const setOperationsDialogOpen = useSetRecoilState(operationsDialogOpenState);

  const handleClick = () => {
    setOperationsDialogOpen(true);
  };

  const operationCount = operations.length;
  const hasOperations = operationCount > 0;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClick}
            className="relative h-9 px-3"
          >
            <Layers className="h-4 w-4" />
            {hasOperations && (
              <Badge
                variant="secondary"
                className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs"
              >
                {operationCount > 99 ? '99+' : operationCount}
              </Badge>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            Operations {hasOperations ? `(${operationCount})` : ''}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

